// extracted by mini-css-extract-plugin
module.exports = {"dropdown_content":"dropdown-button_dropdown_content__8hgyE","category_wrapper":"dropdown-button_category_wrapper__RBQSq"};